﻿﻿export interface ILogisticsOptionNote {
    logDateTime: string;
    notes: string;
    createdBy: string;
    userId: number;
}
